import { useState } from 'react';

/**
 * T106: confirmação para ação que mexe em pedido já finalizado (ex.: reabrir
 * comanda cancelada). Mostra o resumo do que vai acontecer — 2 cliques com
 * contexto, em vez de um toque acidental sem volta.
 */
interface Props {
  titulo: string;
  subtitulo?: string;
  resumo: string[];
  aviso?: string;
  rotuloConfirmar: string;
  onConfirmar: () => void | Promise<void>;
  onCancelar: () => void;
}

export default function ModalConfirmacao({
  titulo,
  subtitulo,
  resumo,
  aviso,
  rotuloConfirmar,
  onConfirmar,
  onCancelar,
}: Props) {
  const [salvando, setSalvando] = useState(false);

  return (
    <div className="fixed inset-0 z-[60] bg-black/70 flex items-center justify-center p-4">
      <div className="card w-full max-w-sm">
        <h2 className="text-lg font-bold text-gray-100 mb-1">{titulo}</h2>
        {subtitulo && <p className="text-sm text-gray-400 mb-3">{subtitulo}</p>}

        <ul className="text-sm text-gray-200 space-y-1 bg-gray-900/50 rounded-lg p-3">
          {resumo.map((linha) => (
            <li key={linha}>{linha}</li>
          ))}
        </ul>

        {aviso && <p className="text-xs text-amber-300 mt-3">⚠️ {aviso}</p>}

        <div className="flex gap-2 mt-4">
          <button onClick={onCancelar} className="btn-secondary flex-1" disabled={salvando}>
            Voltar
          </button>
          <button
            onClick={async () => {
              setSalvando(true);
              try {
                await onConfirmar();
              } finally {
                setSalvando(false);
              }
            }}
            disabled={salvando}
            className="btn-primary flex-1 disabled:opacity-50"
          >
            {salvando ? 'Aguarde...' : rotuloConfirmar}
          </button>
        </div>
      </div>
    </div>
  );
}